// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b3e74ed0","239":"bb1e2b45","455":"cc889c09"}[chunkId] + ".chunk.js";
};